import React, { useState, useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { API } from "../App";
import { Loader2, CheckCircle2, XCircle, Info } from "lucide-react";

export default function DemoApproval() {
  const { token } = useParams();
  const [params] = useSearchParams();
  const action = params.get("action") || "approve";
  const [state, setState] = useState({ loading: true, result: null, message: "" });

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API}/public/demo/approval/${token}?action=${action}`);
        const d = await res.json().catch(() => ({}));
        if (!res.ok) {
          setState({ loading: false, result: "error", message: d.detail || "This link is not valid." });
          return;
        }
        setState({ loading: false, result: d.result, message: d.message });
      } catch {
        setState({ loading: false, result: "error", message: "Could not process this link." });
      }
    })();
  }, [token, action]);

  if (state.loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Loader2 className="w-6 h-6 animate-spin text-amber-600" />
      </div>
    );
  }

  const isApproved = state.result === "approved";
  const isRejected = state.result === "rejected";
  const Icon = isApproved ? CheckCircle2 : isRejected ? XCircle : Info;
  const color = isApproved ? "text-green-600" : isRejected ? "text-rose-600" : "text-amber-600";

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4" data-testid="demo-approval-page">
      <div className="text-center max-w-md bg-white rounded-2xl shadow-sm border p-8">
        <Icon className={`w-14 h-14 mx-auto ${color}`} />
        <h1 className="text-xl font-bold text-slate-900 mt-3" data-testid="demo-approval-result">
          {isApproved ? "Access granted" : isRejected ? "Request rejected" : "Demo request"}
        </h1>
        <p className="text-slate-600 mt-2">{state.message}</p>
      </div>
    </div>
  );
}
